/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type Currency = "AUD" | "CAD" | "CHF" | "EUR" | "GBP" | "JPY" | "MXN" | "USD" | "%future added value";
export type PriceDisplay_transactions = {
    readonly edges?: ReadonlyArray<{
        readonly node: {
            readonly skuId: string | null;
            readonly isPrivateOffer: boolean | null;
            readonly offers: ReadonlyArray<{
                readonly canUseOfferForCheckout: boolean | null;
                readonly expirationDate: string | null;
                readonly amountPerItem: {
                    readonly convertedAmountList: ReadonlyArray<{
                        readonly currency: Currency | null;
                        readonly amount: number | null;
                    } | null> | null;
                } | null;
            } | null> | null;
        } | null;
    } | null> | null;
    readonly " $refType": "PriceDisplay_transactions";
};
export type PriceDisplay_transactions$data = PriceDisplay_transactions;
export type PriceDisplay_transactions$key = {
    readonly " $data"?: PriceDisplay_transactions$data;
    readonly " $fragmentRefs": FragmentRefs<"PriceDisplay_transactions">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PriceDisplay_transactions",
  "type": "TransactionConnection",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "hasSkuId",
      "type": "Boolean",
      "defaultValue": false
    }
  ],
  "selections": [
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "hasSkuId",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "TransactionEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Transaction",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "skuId",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "isPrivateOffer",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "offers",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Offer",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "canUseOfferForCheckout",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "expirationDate",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "amountPerItem",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "FinancialAmount",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "convertedAmountList",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "ConvertedAmountList",
                          "plural": true,
                          "selections": [
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "name": "currency",
                              "args": null,
                              "storageKey": null
                            },
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "name": "amount",
                              "args": null,
                              "storageKey": null
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = 'b9600368fd63d1141e50f8c2450b692c';
export default node;
